/**
 * Storm Models API Service
 */

import api from "../client";
import { ENDPOINTS } from "../endpoints";
import type {
  StormImpactModelResponse,
  AvailableRunsResponse,
  AvailableRunsParams,
  AvailableRun,
} from "../types";

export const stormImpactModelsApi = {
  /**
   * Get all storm impact models for the organization
   */
  stormImpactModels: {
    list: (applicationId?: string) =>
      api.get<StormImpactModelResponse>(ENDPOINTS.STORM_IMPACT_MODELS, {
        params: applicationId ? { application_id: applicationId } : {},
      }),
  },

  /**
   * Get available model runs for a given date and model combination.
   * If forecastDate is omitted, returns the latest available runs.
   */
  availableRuns: {
    list: async (params: AvailableRunsParams): Promise<AvailableRun[]> => {
      const queryParams: Record<string, string> = {
        stormImpactModelId: params.stormImpactModelId,
        weatherModelId: params.weatherModelId,
      };

      if (params.forecastDate) {
        queryParams.forecast_date = params.forecastDate;
      }
      if (params.isExport) {
        queryParams.isExport = "true";
      }

      const response = await api.get<AvailableRunsResponse>(
        ENDPOINTS.AVAILABLE_RUNS,
        { params: queryParams }
      );
      return response?.runs || [];
    },
  },
};

export default stormImpactModelsApi;
